import { get } from 'lodash-es';

export const getErrorMessage = (error) => {
  const message = get(error, ['response', 'data', 'message'], null);

  return message;
};
